import { render, staticRenderFns } from "./sublessorContract copy.vue?vue&type=template&id=058a0ba1&scoped=true"
import script from "./sublessorContract copy.vue?vue&type=script&lang=js"
export * from "./sublessorContract copy.vue?vue&type=script&lang=js"
import style0 from "./sublessorContract copy.vue?vue&type=style&index=0&id=058a0ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a0ba1",
  null
  
)

export default component.exports